import { render, staticRenderFns } from "./FilterReduce.vue?vue&type=template&id=572e66ba&"
import script from "./FilterReduce.vue?vue&type=script&lang=ts&"
export * from "./FilterReduce.vue?vue&type=script&lang=ts&"
import style0 from "./FilterReduce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports